export default function windowOffset () {
  try {
    const body = document.body;
    const doc = document.documentElement;
    let marginRight = '';

    const scrollHeight = Math.max(
      body.scrollHeight, doc.scrollHeight,
      body.offsetHeight, doc.offsetHeight,
      body.clientHeight, doc.clientHeight
    );

    if (doc.clientHeight < scrollHeight) {
      const div = document.createElement('div');
      div.style.overflow = 'scroll';
      div.append(document.createElement('div'));
      body.append(div);
      marginRight = div.offsetWidth - div.children[0].offsetWidth;
      div.remove();
    }

    return marginRight;
  } catch (e) {
    return 0;
  }
}



// WEBPACK FOOTER //
// ./src/utils/windowOffset.js